import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Czech Republic
 */
export const CsPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filtr'],
  [IPageName.instantAccess]: ['/okamzity-pristup/:affilate'],
};
